import React, { Component } from 'react';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';


import Header from './../../Header';
import Cars from './../../Car/Cars';
import CarForm from './../../Car/CarForm';

import ErrorBoundary from './../ErrorBoundary';


class CarsEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "cars" : [], 
            "car" : {},
        };

        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);

        this.load(props.match.params.id);
    }


    load(id)
    {
        Promise.all([
            Core.Instance.Request(Core.Address+"Client/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"Car/Client_id/"+id+"?by=date_delivery&order=desc", null, "GET")
        ])
        .then((data) => {
            if(data[0] == null)
            {
                ErrorManager.Instance.Handle("Aucun client ne possède cet identifiant.");
                return;
            }
            this.setState({
                "client" : data[0],
                "cars" : data[1] != null ? data[1] : [] 
            });
        });
    }

    handleRedux(event)
    {
        let car = this.state.car;
        car[event.target.name] = event.target.value;
        this.setState({
            "car" : car
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.car).length <= 0)
        {
            ErrorManager.Instance.Error("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let car = this.state.car;
        //car.date_first_code = car.date_first_code != null ? car.date_first_code/1000 : null;
        //car.date_begin = car.date_begin != null ? car.date_begin/1000 : null;
        //car.date_delivery = car.date_delivery != null ? car.date_delivery/1000 : null;
        car.Client_id = this.state.client.id;
        let request = null;
        request = Core.Instance.Request(Core.Address+"Car", car, "POST");
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.client.id, "Enregistrement d'un nouveau véhicule.");
        }).then(() => {
            ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            window.location.reload();
        });      
    }

    render()
    {
        document.title = "W-F: Voitures liées "+this.state.client.name;

        return (
            <ErrorBoundary>
                <Header buttons={ [
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Véhicules possédés par le client</span>
                                        {/* <span className="float-right" data-toggle="modal" data-target="#addCarModal">
                                            <a href="#"><li className='fas fa-plus'></li> <u>Ajouter un véhicule</u></a>    
                                        </span> */}
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Cars cars={ this.state.cars } editing={ true } />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Ajout d'un véhicule possédé</span>
                                        <span className="float-right">
                                            <button className="btn btn-primary float-right" onClick={ this.submit }><li className="fas fa-save"> </li> Enregistrer</button>   
                                        </span>
                                    </div>
                                </div>
                                <CarForm car={ this.state.car } onChange={ this.handleRedux } />
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}
export default CarsEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/Car/CarsEdit.js